export const environment = {
  env: 'production',
  apiUrl: 'https://api.winston.dev2.scrij.com',
};
